import * as yup from 'yup';

export const VisitSheetSchema = yup.object({
  question: yup.string().required(),
  questionDate: yup.date().required(),
  questionToId: yup.string().required(),
  answer: yup.string().notRequired().nullable(),
  answerDate: yup.mixed().when('answer', {
    is: (v: string) => !!v,
    then: yup
      .date()
      .required()
      .test('higher-than-question', 'higher-than-question', function (value) {
        return !!value && new Date(this.parent.questionDate) < new Date(value);
      }),
  }),
  answerFromId: yup.mixed().when('answer', {
    is: (v: string) => !!v,
    then: yup.string().required(),
  }),
});

export interface IVisitSheet {
  question: string;
  questionDate: Date;
  questionToId: string;
  answer?: string;
  answerDate?: Date;
  answerFromId?: string;
}

export const CreateVisitSheetSchema = yup
  .object({
    residentId: yup.string(),
  })
  .concat(VisitSheetSchema);

export interface ICreateVisitSheet extends IVisitSheet {
  residentId: string;
}

export const UpdateVisitSheetSchema = yup
  .object({
    id: yup.string(),
  })
  .concat(VisitSheetSchema);

export interface IUpdateVisitSheet extends IVisitSheet {
  id: string;
}
